import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./NotFound.css";
import { useLocale } from "@/i18n/useLocale";

function NotFound() {
  const { t } = useLocale();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="not-found-page">
      <Navbar />
      <main id="main-content" className="not-found-page__content">
        <p className="not-found-page__eyebrow">404</p>
        <h1 className="not-found-page__title">{t.notFound.title}</h1>
        <Link to="/" className="not-found-page__link" title="Volver al inicio">
          Volver al inicio
        </Link>
      </main>
      <Footer />
    </div>
  );
}

export default NotFound;
